"use client";
import Image from 'next/image';
import { getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';

interface TextWithBigImageAndIconProps {
  text?: string;
  imageSrc?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  /** Hero image metadata with focus-point for object-position */
  imageMetadata?: ImageMetadata;
  /** Use fixed height container for hero images */
  fixedHeight?: boolean;
}

// Tiny 1x1 gray placeholder for blur effect (base64 encoded)
const BLUR_DATA_URL = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBEQCEAwEPwAB//9k=";

export default function ImageWithText({
  text,
  imageSrc,
  priority = false,
  imageMetadata,
  fixedHeight = false
}: TextWithBigImageAndIconProps) {
  // Use fallback if imageSrc is empty, undefined, or invalid
  const validImageSrc = imageSrc && imageSrc.trim() !== '' ? imageSrc : 'https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png';

  return (
    <div className={`relative w-full ${fixedHeight ? 'aspect-[16/9] max-h-[475px] overflow-hidden' : ''}`}>
      <Image
        src={validImageSrc}
        alt={text || "News image"}
        width={800}
        height={500}
        priority={priority}
        sizes="(max-width: 768px) 100vw, (max-width: 1250px) 50vw, 33vw"
        className={`w-full ${fixedHeight ? 'h-full' : 'h-auto'} object-cover`}
        style={getFocusPointStyle(imageMetadata)}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        placeholder="blur"
        blurDataURL={BLUR_DATA_URL}
      />

      {text && (
        <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-FFFFFF p-2 sm:p-3 md:p-4">
          <p className="text-start text-14-tamil-600 text-FFFFFF line-clamp-1 leading-[1.4]">
            {text}
          </p>
        </div>
      )}
    </div>
  );
}
